<template>
    <div class="results-page">
        <a class="skip-main" href="#main">Skip to main content</a>
        <!-- TODO: extract breadcrumb to component -->
        <div class="row bg-light-gray py-2 mt-2">
            <div class="container">
                <div class="row">
                        <b-breadcrumb class="mb-0 pl-2 col-6 d-none d-md-flex" :items="crumbs"></b-breadcrumb>
                        <div class="col-md-6 breadcrumb d-flex justify-content-md-end justify-content-start ml-md-0 ml-2" >
                            <router-link :to="{name: 'Home'}">
                                <strong>&lt; Back to journey planner</strong>
                            </router-link>
                        </div>
                </div>
            </div>
        </div>
        <div class="container" id="main" tabindex="-1">
            <div class="row mt-4 ">
                <div class="col-6 pl-0 d-none d-md-block">
                     <h1 class="color-secondary-blue ml-2 d-flex d-md-block">Select a journey</h1>
                     <div class="row">
                        <p class="col-3-flex ml-4 text-left mt-3"><strong>Sort option:</strong></p>
                        <vue-select
                        class="mt-2 col-5 d-block"
                        v-model="selectedFilter"
                        :options="filterOptions"
                        @input="setFilter"
                        dropdown
                        >
                        </vue-select>
                    </div>
                </div>
                <div v-if="!resultsAreLoading" class="col-6 d-none d-md-block">
                    <div class="d-flex mt-1 pl-4">
                        <div class="appointment-details-wrapper rounded">
                            <h3 class="mt-2">
                                <svg-icon name="nhs/calendar" width="auto" height="1.5em" class="ml-2 mr-2"></svg-icon>
                                    Appointment : {{ searchQuery.arrive_at_date }} </h3>
                            <h3 class="mb-1 mr-3">
                                <svg-icon name="nhs/clock" width="auto" height="1.5em" class="ml-2 mr-2"></svg-icon>
                                 Appointment time : {{ searchQuery.arrive_at_time }} - {{ searchQuery.return_time }} </h3>
                        </div>
                    </div>
                </div>
            </div>
             <!-- that is a mobile view -->
                <div class="row d-md-none">
                    <h1 class="color-secondary-blue float-left mt-2 ml-2">Select a journey</h1>
                </div>
                <div class="row d-md-none">
                    <p class="col-3-flex ml-2 text-left mt-2"><strong>Sort option:</strong></p>
                    <vue-select
                        class="col-9 ml-1"
                        v-model="selectedFilter"
                        :options="filterOptions"
                        @input="setFilter">
                    </vue-select>
                </div>
                <div v-if="!resultsAreLoading" class="row d-block d-md-none mt-4">
                    <div class="mt-1 p-2">
                        <div class="appointment-details-wrapper rounded">
                            <h3 class="mt-2">
                                <svg-icon name="nhs/calendar" width="auto" height="1.5em" class="ml-2 mr-2"></svg-icon>
                                    Appointment : {{ searchQuery.arrive_at_date }} </h3>
                            <h3 class="mb-1 mr-3">
                                <svg-icon name="nhs/clock" width="auto" height="1.5em" class="ml-2 mr-2"></svg-icon>
                                 Appointment time : {{ searchQuery.arrive_at_time }} - {{ searchQuery.return_time }} </h3>
                        </div>
                    </div>
                </div>
            <!-- Journey cards -->
            <results-loading v-if="resultsAreLoading"></results-loading>
            <div class="row results mt-2">
                <result-item v-for="(result, index) in sortedResultItems" :key="index" :payload="result" :carbon="getCo2" :lowestCarbon="lowestCo2" :highestCarbon="highestCo2"></result-item>
            </div>
        </div>
    </div>
</template>

<script>
import ResultItem from '@/components/ResultItem.vue'
import pusher from '@/broadcasting/app-pusher'
import _ from 'lodash'
import ResultsLoading from '@/components/ResultsLoading.vue'
import {
    mapState,
    mapMutations,
    mapActions,
    mapGetters,
} from 'vuex'
import mutationsMapping from '@/store/mutations-mapping'


export default {
    name: 'results',
    components: {
        ResultItem,
        ResultsLoading,
    },
    data() {
        return {
            active: true,
            hash: this.$route.params.hash,
            sortOptions: {
                cost: 'Lowest cost',
                'depature-time': 'Departure time',
                'travel-time': 'Travel time',
                'arrival-time': 'Arrival time',
                'wait-time': 'Wait time',
                'walk-distance': 'Walking distance',
                'least-changes': 'Least changes',
            },
            filterOptions: [
                { value: 'cost', label: 'Lowest cost' },
                { value: 'depature-time', label: 'Departure time' },
                { value: 'travel-time', label: 'Travel time' },
                { value: 'arrival-time', label: 'Arrival time' },
                { value: 'wait-time', label: 'Wait time' },
                { value: 'walk-distance', label: 'Walking distance' },
                { value: 'least-changes', label: 'Least changes' },
                { value: 'carbon-emission', label: 'Emissions' },
            ],
            selectedFilter: { value: 'cost', label: 'Lowest cost' },
            selectedSort: 'cost',
            crumbs: [
                {
                    text: 'Plan your journey',
                    to: { name: 'Home' },
                },
                {
                    text: 'Select journey option',
                    active: true,
                },
            ],
            resultsCount: 0,
            retrievedResultsCount: 0,
            isLoadingResults: true,
        }
    },
    watch: {
        results() {
            if (this.resultsAreLoading) {
                this.isLoadingResults = false
            }
        },
    },
    created() {
        this.active = false
    },
    mounted() {
        this.$parent.$on('toggleNav', () => {
            this.active = !this.active
        })
        this.subscribeToPusherChannel()
        console.log(this.$route)
    },
    computed: {
        ...mapState([
            'isLoading',
            'results',
            'searchQuery',
        ]),
        ...mapGetters([
            'allResultsRetrieved',
            'getCo2',
        ]),
        sortedResultItems() {
            if (this.selectedSort === 'travel-time') {
                return _.sortBy(this.results, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.duration.value
                }])
            }

            if (this.selectedSort === 'arrival-time') {
                return _.sortBy(this.results, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.depart.arrival_at
                }])
            }

            if (this.selectedSort === 'wait-time') {
                return _.sortBy(this.results, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.depart.wait_time
                }])
            }

            if (this.selectedSort === 'walk-distance') {
                return _.sortBy(this.results, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return parseFloat(o.journey.total_walking_distance)
                }])
            }

            if (this.selectedSort === 'depature-time') {
                return _.sortBy(this.results, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.depart.departure_at
                }])
            }
            if (this.selectedSort === 'carbon-emission') {
                return _.sortBy(this.results, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.carbon_emission
                }])
            }

            if (this.selectedSort === 'least-changes') {
                return _.sortBy(this.results, [(o) => {
                    if (o.showPlaceholder) return 1000000
                    return o.journey.depart.stages.length
                }])
            }

            if (this.selectedSort === 'cost') {
                return _.sortBy(this.results, [(o) => {
                    if (o.showPlaceholder) return 1000000

                    let costValue = o.journey.cost
                    if (_.toLower(costValue) === 'unknown') return 1000000
                    if (_.toLower(costValue) === 'free') return 0

                    costValue = costValue.replace(/\D/g, '')
                    if (costValue === '') {
                        return null
                    }
                    return _.parseInt(costValue)
                }])
            }
            return this.results
        },
        resultsAreLoading() {
            if (this.isLoading) {
                return true
            }
            if (!this.allResultsRetrieved) {
                return true
            }
            return this.resultsCount !== this.retrievedResultsCount
        },
        lowestCo2() {
            const lowest = this.getCo2[0];
            return lowest;
        },
        highestCo2() {
            const highest = this.getCo2[this.getCo2.length - 1];
            return highest;
        },
    },
    methods: {
        ...mapMutations(mutationsMapping),
        ...mapActions([
            'retrieveResults',
            'retrieveSingleJourney',
        ]),
        getButtonClass(index) {
            if (index === this.selectedSort) {
                return 'btn-outline-primary'
            }

            return 'btn-outline-secondary'
        },
        selectSort(index) {
            this.selectedSort = index
        },
        toggleNav() {
            this.$parent.$emit('toggleNav')
        },
        subscribeToPusherChannel() {
            if (!this.allResultsRetrieved) {
                this.retrieveResults(this.hash)
            }
            const channel = pusher.subscribe(`query.${this.hash}`)

            channel.bind('results.retrieved', (retrieved) => {
                this.resultsCount = retrieved.journey_count
                for (let i = 0; i < this.resultsCount; i += 1) {
                    this.results.push({ showPlaceholder: true, journey: {} })
                }
                channel.bind('journey.processed', (data) => {
                    this.retrieveSingleJourney({
                        hash: this.hash,
                        journeyID: data.journeyID,
                    }).then(() => {
                        this.retrievedResultsCount += 1
                    })
                })
            })
            console.log(this.results)
        },
        goToHome() {
            this.$router.push({ name: 'Home' })
        },
        setFilter(value) {
            this.selectedSort = value.value
        },
    },
}
</script>
<style scoped>
.appointment-details-wrapper{
    margin-left: auto;
    background: #E2E2F5;
    padding: 10px;
}


</style>
